export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14674.a6dd81b6.jpg";